import React from 'react'

function Card1() {
  return (
    <div className='w3-c1'>
      <div className='flex-row'>
        <div className='face'><img src="images/bipolar/face.png" alt="" /></div>
        <h3>BIPOLAR - Fashion Project</h3>
      </div>
      <h3>A Cutting-Edge Fusion of Polish rap culture and high quality fashion. Great marketing campaign + The best quality</h3>
      <div className='man-flex'>
        <div>
          <div><img src="images/bipolar/man1.jpg" alt="" /></div>
          <p>Collab with 150k fanpage’s via Instagram</p>
        </div>
        <div>
          <div><img src="images/bipolar/man2.jpg" alt="" /></div>
          <p>Tiktok Viral Marketing</p>
        </div>
        <div>
          <div><img src="images/bipolar/man3.jpg" alt="" /></div>
          <p>Forwarding customers to own Instagram fanpage: 14k+ followers. Many competitions</p>
        </div>
      </div>
      <div>
        <div className='gp'><img src="images/bipolar/Group5.png" alt="" /></div>
      </div>
      <div className='bottom-line'>
        <p>Influencer Marketing | Viral Marketing | Real-Time Marketing | Fashion Design (Figma) | Project Management</p>
      </div>
    </div>
  )
}

export default Card1